/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./giftorder.vue?vue&type=template&id=10255c98&scoped=true"
import script from "./giftorder.vue?vue&type=script&lang=js"
export * from "./giftorder.vue?vue&type=script&lang=js"
import style0 from "./giftorder.vue?vue&type=style&index=0&id=10255c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10255c98",
  null
  
)

export default component.exports